import script from "./TagValue.vue?vue&type=script&setup=true&lang=js"
export * from "./TagValue.vue?vue&type=script&setup=true&lang=js"

import "./TagValue.vue?vue&type=style&index=0&id=5ad52b3c&lang=scss"

const __exports__ = script;

export default __exports__